import React, { useState } from "react";
import { Flex, Button, OpenOutsideIcon, LinkIcon } from "@fluentui/react-northstar";
import DashboardItem from "../components/dashboardItem";
import WeekPicker from "../components/pickers/weekPicker";
import YearMonthPicker from "../components/pickers/yearMonthPicker";
import Alert from "../components/common/alert";
import styles from "../common.module.scss";

import { useApp } from "../contexts/appContext";
import { useDashboard } from "../queries";
import { getErrorMessage, isAuthIssue } from "../queries/queryClient";
import { getEmptyDashboard } from "../services/dataService";
import { getPreviousMondayDate } from "../common/dateOperations";
import { copyToClipboard } from "../common/textOperations";
import { getSettings } from "../services/settingsService";

const Dashboard = () => {
    document.title = "Dashboard";
    const [startOfWeek, setStartOfWeek] = useState(getPreviousMondayDate(new Date()));
    const { state: appState } = useApp();
    const settings = getSettings();

    const { data: dashboardData, error } = useDashboard(startOfWeek);
    const dashboard = dashboardData ?? getEmptyDashboard();

    const weekChanged = (value: Date) => {
        setStartOfWeek(value);
    };

    const openOrCopyLink = () => {
        const link: string = import.meta.env.VITE_PBI_URL ?? "";
        if (settings.copyLinks) {
            copyToClipboard(link);
        } else {
            window.open(link);
        }
    };

    if (error) {
        return <Alert type="error" authIssue={isAuthIssue(error)}>{getErrorMessage(error)}</Alert>;
    }

    return (
        <div>
            <div className={styles.centerContainer} style={{ padding: "1em 0.5em", width: 356 }}>
                <Flex column gap="gap.medium">
                    <WeekPicker onChange={weekChanged} />
                    <DashboardItem value={dashboard.sum} max={40} text="hodin za týden" />
                    <span></span>
                    <DashboardItem value={dashboard.monday} max={8} text="pondělí" />
                    <DashboardItem value={dashboard.tuesday} max={8} text="úterý" />
                    <DashboardItem value={dashboard.wednesday} max={8} text="středa" />
                    <DashboardItem value={dashboard.thursday} max={8} text="čtvrtek" />
                    <DashboardItem value={dashboard.friday} max={8} text="pátek" />
                    <DashboardItem value={dashboard.saturday} max={8} text="sobota" />
                    <DashboardItem value={dashboard.sunday} max={8} text="neděle" />
                    <span></span>
                    <YearMonthPicker />
                </Flex>
            </div>

            <div className={styles.footer} style={{ background: appState.backgroundColor }}>
                <Flex gap="gap.small" className={styles.centerContainer}>
                    <Flex.Item push>
                        <Button content="Power BI Dashboard" primary
                            icon={settings.copyLinks ? <LinkIcon outline /> : <OpenOutsideIcon outline />}
                            onClick={openOrCopyLink}
                        />
                    </Flex.Item>
                </Flex>
            </div>
        </div>
    );
};

export default Dashboard;
